module.exports = __webpack_public_path__ + "daee1b9b039bf356b8cc59fba9d09dfa.png";